"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function nativeClone(source, existingObj) {
    return Object.assign(existingObj || {}, source);
}
function customClone(source, existingObj) {
    var result = existingObj || {};
    if (source) {
        for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
            var key = _a[_i];
            result[key] = source[key];
        }
    }
    return result;
}
/**
 * @internal
 */
exports.cloneObject = Object.assign ? nativeClone : customClone;
//# sourceMappingURL=cloneObject.js.map